import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import 'primereact/resources/themes/nova-accent/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Card } from "primereact/card";
import { Modal, Form, Col, Row, Button as ReactButton } from 'react-bootstrap';
import { handleRequest } from '../../redux/config/env';
import { Form as FormAnt } from 'antd';
import { FormattedMessage } from "react-intl";
import 'react-contexify/dist/ReactContexify.min.css';
import { Item, MenuProvider } from 'react-contexify';
import CustomMaterialMenu from '../settings/ForComponents/CustomMaterialMenu';
import HowtoUse from '../standardization/HowtoUse';
import Settings from '../standardization/Settings';
import Whatis from '../standardization/Whatis';
import { Table, Input, Select, InputNumber, Checkbox } from 'antd';
import moment from 'moment'

const { Column } = Table;
const { Option } = Select;
export class Release extends Component {

    constructor() {
        super();
        this.state = {
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,


            archiveDocumentSelectItems: [],
            volumeSelectItems: [],
            selectedVolumeIds: [],
            archivingVolumeList: [],
            archivingVolumeId: 0,
            archiveDocumentId: null,
            methodOfTransfer:"",

            dynamicAttributes: [],
            authorizations: [],
            Inputs: [],
            isAdmin: false,
            howToUseSetting: false,
            whatIsSetting: false,
            formId: null
        };
        // this.actionTemplate = this.actionTemplate.bind(this);
        // this.showSuccess = this.showSuccess.bind(this);
        // this.showError = this.showError.bind(this);
        // this.showWarning = this.showWarning.bind(this);

    }

    formRef = React.createRef();


    componentDidMount = async () => {
        this.getDynamicMenu();

        if (this.props.auth !== undefined)
            if (this.props.auth.user !== null) {

                this.setState({
                    isAdmin: this.props.auth.user.userType === 2 ? true : false
                });

            }

        this.setStandardizations();
        this.setComboboxes();
        // this.restartTable();


    }

    save = async () => {

        const selectedVolumeIds = this.state.selectedVolumeIds;
        const list = [];
        if (Boolean(selectedVolumeIds) && selectedVolumeIds.length > 0) {

            selectedVolumeIds.forEach(element => {
                const obj = {
                    id: element,
                    archiveDocumentId: this.state.archiveDocumentId,
                    methodOfTransfer: this.state.methodOfTransfer
                };

                list.push(obj);
            });

            const response = await handleRequest("POST", "/ArchiveVolume/release", list);

            if (response.data !== null && response.data !== undefined) {
                if (response.data === "SUCCESS-ArchiveVolume-001") { 
                    this.showSuccess();
                    this.resetInputs();
                    this.restartTable();
                }
                else if (response.data === "ERROR-ArchiveVolume-001") {
                    this.showError("An error was occured please try again later !");
                } else if (response.data === "ERROR-ArchiveVolume-002") {
                    this.showError("There are some volumes that is already in the last stock(archive).");
                }
            }
          
        }
        else this.showError("Please select volumes");


    }

    edit = (row) => {


        this.setState({
            archivingVolumeId: row.id,
            archiveDocumentId: row.archiveDocumentId,
            volumeNumber: row.volumeNumber,
            startSerialNo: row.startSerialNo,
            endSerialNo: row.endSerialNo,
            volumeClosed: row.volumeClosed,
            folderName: row.folderName,
            volumeText: row.volume,
            hideSave: true,
            hideUpdate: false,
            hideInputs: false,

        });

    }


    delete = async () => {
        const obj = {
            id: this.state.archivingVolumeId
        }

        await handleRequest("POST", "/ArchiveVolume/delete", obj);

        this.restartTable();
        this.showSuccess();
        this.showOrHideDeleteModal();
    }

    deleteModal = (row) => {
        this.setState({
            modalDeleteShow: true,
            archivingVolumeId: row.id
        });
    }

    showOrHideDeleteModal = () => {
        this.setState({
            modalDeleteShow: !this.state.modalDeleteShow
        });

        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }



    showSuccess(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageSuccess1" defaultMessage="Successfull" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Success"
        });
    }

    showError(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageError1" defaultMessage="An error was occured please try again later !" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Error"
        });
    }

    showWarning(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageCheckInputs" defaultMessage="Something went wrong. Please check inputs." />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Warning"
        });
    };




    actionTemplate(rowData, column) {


        return <React.Fragment>
            <CustomMaterialMenu row={rowData} onDeleteRow={this.deleteModal.bind(this)} onEditRow={this.edit.bind(this)} />
        </React.Fragment>;


    }


    restartTable = async () => {
        const response = await handleRequest("GET", "/ArchiveVolume/getAllByCompany");

        if (response.data.length !== 0) {
            const list = response.data;
            list.forEach(element => {
                element.key = element.id
            });
            this.setState({
                archivingVolumeList: list,
            });
        }

        if (response.data.length === 0) {
            this.setState({
                archivingVolumeList: [],
            });
        }
    }


    setComboboxes = async () => {
        // const resDepList = await handleRequest("GET", "/ArchiveDocument/getResults");
        const response = await handleRequest("GET", "/ArchiveVolume/getAllByCompany");
        if (response.data.length !== 0) {
            const list = response.data;
            list.forEach(element => {
                element.key = element.id
            });
            this.setState({
                archivingVolumeList: list,
            });

            const resDepList = list.filter(p => this.getDetentionMoment(p) === true)
            console.log(list);
            console.log(resDepList);
            if (resDepList.length > 0) {
                const list2 = [];
                resDepList.forEach(element => {

                    element.description = element.folderName;
                    if (list2.length === 0)
                        list2.push(element);
                    else
                        if (list2.findIndex(p => p.archiveDocumentId === element.archiveDocumentId) === -1)
                            list2.push(element);

                });
                this.setState({
                    archiveDocumentSelectItems: list2
                });
            } else {
                this.setState({
                    archiveDocumentSelectItems: []
                });
            }

        }


    }
    setStandardizations = async () => {
        const responseDP = await handleRequest("POST", "/DynamicPage/getFormAttributes", { pageName: "ArchivingVolume" });
        if (responseDP.data.length > 0) {
            this.setState({
                dynamicAttributes: responseDP.data
            });
        } else {
            this.setState({
                dynamicAttributes: []
            });
        }

        const obj = {
            pageName: "ArchivingVolume"
        };

        const responseInputs = await handleRequest("POST", "/DynamicInputs/getResult", obj);
        if (responseInputs.data.length !== 0) {
            this.setState({
                Inputs: responseInputs.data,
            });
        } else {
            this.setState({
                Inputs: [],
            });
        }

        //const menuObj = this.props.auth.user.authList.find(p => Boolean(p.dynamicMenu) && p.dynamicMenu.page === "ArchivingVolume");

        try {
            this.setState({
                authorizations: this.props.auth.user.authList.filter(p => p.menuId === this.state.formId || p.form === "All")
            });

        } catch (error) {

        }

    }



    getDynamicMenu = async () => {
        const responseTree = await handleRequest("GET", "/DynamicMenu/getTreeModel");
        if (responseTree.data.length !== 0) {
            var element = responseTree.data.treeTable;

            for (let index = 0; index < element.length; index++) {
                var result = this.searchTree(element[index], this.props.location.pathname.split("/").pop());

                if (result !== null)
                    break;
            }

            this.setState({
                formId: result.data.id
            });

            this.getUserSettings();
        } else {
            this.setState({
                formId: null
            });
        }
    }





    createNew = () => {

        this.setState({
            hideInputs: !this.state.hideInputs,
            selectedVolumeIds: [],
            archivingVolumeId: 0,
            archiveDocumentId: null,
            methodOfTransfer:"",
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,
        });

    }


    stop = () => {

        this.setState({
          
            selectedVolumeIds: [],
            archivingVolumeId: 0,
            archiveDocumentId: null,
            methodOfTransfer:"",
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,
        });

    }



    resetInputs = () => {
        this.setState({
           
          
            selectedVolumeIds: [],
            archivingVolumeId: 0,
            archiveDocumentId: null,
            methodOfTransfer:"",

            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,


        });
    }


    cancel = () => {

        this.resetInputs();
    }



    searchTree = (element, matchingTitle) => {
        if (element.data.page == matchingTitle) {
            return element;
        } else if (element.children != null) {
            var i;
            var result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchTree(element.children[i], matchingTitle);
            }
            return result;
        }
        return null;
    }





    getUserSettings = async () => {
        const responseUserSettings = await handleRequest("GET", "/UserPageSettings/getFindByFormAndUserId/" + this.state.formId);
        if (responseUserSettings.data.length !== 0) {
            this.setState({
                userSettings: responseUserSettings.data,
                howToUseSetting: responseUserSettings.data.howToUseSetting,
                whatIsSetting: responseUserSettings.data.whatIsSetting
            });
        } else {
            this.setState({

                howToUseSetting: false,
                whatIsSetting: false
            });
        }
    }


    showOrHideModalMessage = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }


    getDetentionMoment = (row) => {

        if (row.volumeClosedDate) {
            var fd = moment(new Date(row.volumeClosedDate));

            let type = row.detentionPeriodType;
            switch (type) {
                case "year":
                    fd.add(row.detentionPeriod, "years");
                    break;
                case "month":
                    fd.add(row.detentionPeriod, "months");
                    break;
                case "week":
                    fd.add(row.detentionPeriod, "weeks");
                    break;
                case "day":
                    fd.add(row.detentionPeriod, "days");
                    break;

                default:
                    break;
            }

            if (fd.isBefore(moment()))
                return true;
            else return false;
        }

        return false;

    }


    render() {

        const onFinish = values => {
            console.log('Success:', values);
        };

        const onFinishFailed = errorInfo => {
            console.log('Failed:', errorInfo);
        };

        const layout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };


        return <div>

                <MenuProvider id="menu_id">


                    <Modal
                        show={this.state.modalDeleteShow}
                        onHide={this.showOrHideDeleteModal}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">Chosen material/equipment will be deleted !</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Are you sure?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <ReactButton variant="secondary" onClick={this.showOrHideDeleteModal}>Cancel</ReactButton>
                            <ReactButton variant="danger" onClick={this.delete} >Delete</ReactButton>
                        </Modal.Footer>
                    </Modal>

                    <Card>

                        <div>
                            <Row>
                                <Col sm="1">
                                    <Settings formId={this.state.formId} onSaveChanges={this.getUserSettings.bind(this)} ></Settings>

                                </Col>
                                <Col sm="10">
                                </Col>
                                <Col sm="1" style={{ textAlign: "right" }}>
                                    {!this.state.howToUseSetting && <HowtoUse formId={this.state.formId} ></HowtoUse>

                                    }
                                </Col>
                            </Row>
                        </div>

                        <div>
                            <Row>
                                <Col sm="10">
                                </Col>
                                <Col sm="2">
                                    {/*<Button style={{ width: '100%' }} id='create-new' icon="pi pi-plus" onClick={this.createNew} label="Create New" />*/}
                                    {this.state.hideInputs &&
                                        <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="primary" onClick={this.createNew}><FormattedMessage id="GeneralButtonCreateNew" defaultMessage="Create New" /></ReactButton>
                                    }

                                    {!this.state.hideInputs &&
                                        <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="danger" onClick={this.stop}><FormattedMessage id="GeneralButtonStopProcess" defaultMessage="Stop the process" /></ReactButton>
                                    }

                                </Col>
                            </Row>
                        </div>

                        <div hidden={this.state.hideInputs} style={{ marginBottom: '2rem' }}>

                            <FormAnt
                                {...layout}
                                initialValues={{ remember: false }}
                                onFinish={this.save}
                                onFinishFailed={onFinishFailed}
                                ref={this.formRef}
                            >

                                {
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Folder Name" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type abbreviation" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Select placeholder="" value={this.state.archiveDocumentId} onChange={(value) => {

                                                    const res = this.state.archivingVolumeList.filter(p => this.getDetentionMoment(p) === true && p.archiveDocumentId === value)

                                                    this.setState({
                                                        archiveDocumentId: value,
                                                        volumeSelectItems: res
                                                    })
                                                }}>
                                                    <Option key={0} value={0}>Select</Option>
                                                    {this.state.archiveDocumentSelectItems.map(i => (
                                                        <Option key={i.archiveDocumentId} value={i.archiveDocumentId}>{i.description}</Option>
                                                    ))}
                                                </Select>


                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Volume" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type abbreviation" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Select mode="tags" placeholder="" value={this.state.selectedVolumeIds} onChange={(value) => {
                                                    this.setState({
                                                        selectedVolumeIds: value
                                                    })
                                                }}
                                                >
                                                    <Option key={0} value={0}>Select</Option>
                                                    {this.state.volumeSelectItems.map(i => (
                                                        <Option key={i.id} value={i.id}>{i.volume}</Option>
                                                    ))}
                                                </Select>

                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }

                                {
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="(Method of Transfer) No" />}
                                        name="OrganizationalLevelRoleGroup"
                                        id="OrganizationalLevelRoleGroup"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type document type" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Input id="todo" value={this.state.methodOfTransfer} onChange={(e) => {
                                                    this.setState({
                                                        methodOfTransfer: e.target.value
                                                    })
                                                }} />
                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }


                                {
                                    <FormAnt.Item
                                        label={<FormattedMessage id="todo" defaultMessage="Surrender To" />}
                                        name="OrganizationalLevelDesignation"
                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type abbreviation" /> }]} >
                                        <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                            <Col sm="6">
                                                <Select placeholder="" >
                                                    <Option key={0} value={0}>Select</Option>

                                                </Select>

                                            </Col>
                                            <Col sm="6">
                                            </Col>
                                        </Form.Group>
                                    </FormAnt.Item>
                                }





                                <div hidden={this.state.hideSave}>
                                    {
                                        <Row>
                                            <Col sm="3">
                                            </Col>
                                            <Col sm="5">
                                                {/*<Button style={{ width: '100%' }} id='save-orgLevel' className="p-button-success" onClick={this.saveOrganizationalLevel} label="Save" />*/}
                                                <ReactButton id="OrganizationalLevelSaveButton" type="submit" style={{ width: '100%' }}
                                                    variant="success" ><FormattedMessage id="GeneralButtonSave" defaultMessage="Save" /></ReactButton>
                                            </Col>
                                            <Col sm="3">
                                            </Col>
                                        </Row>
                                    }
                                </div>



                                <div hidden={this.state.hideUpdate}>
                                    {
                                        <Row>
                                            <Col sm="3">
                                            </Col>
                                            <Col sm="2">
                                                {/*<Button style={{ width: '100%' }} id='cancel-orgLevel' onClick={this.changeButtonCancel} className="p-button-danger" label="Cancel" />*/}
                                                <ReactButton id="OrganizationalLevelCancelButton" style={{ width: '100%' }} variant="secondary" onClick={this.cancel}>
                                                    <FormattedMessage id="GeneralButtonCancel" defaultMessage="Cancel" /></ReactButton>
                                            </Col>
                                            <Col sm="3">
                                                {/*<Button style={{ width: '100%' }} id='update-orgLevel' onClick={this.updateDone} className="p-button-warning" label="Update" />*/}
                                                <ReactButton id="OrganizationalLevelUpdateButton" style={{ width: '100%' }} variant="warning" type="submit">
                                                    <FormattedMessage id="GeneralButtonUpdate" defaultMessage="Update" /></ReactButton>
                                            </Col>
                                            <Col sm="3">
                                            </Col>
                                        </Row>
                                    }
                                </div>
                                <Modal
                                    show={this.state.modalMessage}
                                    onHide={this.showOrHideModalMessage}
                                    backdrop="static"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>

                                    <Modal.Header closeButton>
                                        <Modal.Title id="contained-modal-title-vcenter">
                                            <Row >
                                                <Col sm="12">
                                                    {this.state.messageTip == "Success" &&
                                                        <i className="fas fa-check fa-2x" style={{ color: '#00ff2a' }} />}

                                                    {this.state.messageTip == "Warning" &&
                                                        <i className="fas fa-exclamation-circle fa-2x" style={{ color: '#faca2a' }} />}

                                                    {this.state.messageTip == "Error" &&
                                                        <i className="fas fa-times fa-2x" style={{ color: '#ff0400' }} />}
                                                </Col>
                                            </Row>
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <Row >
                                            <Col sm="12">
                                                {this.state.message}
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <ReactButton variant="secondary" onClick={this.showOrHideModalMessage}><FormattedMessage id="GeneralTextClose" defaultMessage="Close" /></ReactButton>
                                    </Modal.Footer>
                                </Modal>
                            </FormAnt>
                        </div>

                        {this.state.archivingVolumeList.length > 0 && <Table style={{ marginTop: '3rem' }} size={`small`} dataSource={this.state.archivingVolumeList.filter(p => p.received === false)} bordered scroll={{ x: 800, scrollToFirstRowOnChange: true }} >


                            <Column title="S/N" dataIndex="index" />
                            {/* <Column title="Folder Name" render={(value, row, index) => {

                                if (Boolean(row.archiveDocument))
                                    return row.archiveDocument.folderName;

                            }} />
                            <Column title="Volume" render={(value, row, index) => {
                                if (Boolean(row.archiveDocument) && Boolean(row.archiveDocument.folderCode))
                                    return row.archiveDocument.folderCode + "-" + row.volumeNumber;
                                else return row.volumeNumber;

                            }} />

                            <Column title="Document Info" render={(value, row, index) => {

                                if (Boolean(row.archiveDocument) && Boolean(row.archiveDocument.documentLog))
                                    return row.archiveDocument.documentLog.description;
                            }} /> */}
                            <Column title="Box No" dataIndex="methodOfTransfer"

                            />
                            <Column title="Folder Name" dataIndex="folderName"

                            />
                            <Column title="Volume" dataIndex="volume" />

                            <Column title="Document Info" dataIndex="documentInfo" />
                            <Column title="Serial No" render={(value, row, index) => {
                                return row.startSerialNo + "-" + row.endSerialNo;

                            }} />
                            {/* 
                            <Column title="Detention Date" render={(value, row, index) => {

                                if (row.volumeClosedDate) {
                                    var fd = moment(new Date(row.volumeClosedDate));

                                    let type = row.detentionPeriodType;
                                    switch (type) {
                                        case "year":
                                            fd.add(row.detentionPeriod, "years");
                                            break;
                                        case "month":
                                            fd.add(row.detentionPeriod, "months");
                                            break;
                                        case "week":
                                            fd.add(row.detentionPeriod, "weeks");
                                            break;
                                        case "day":
                                            fd.add(row.detentionPeriod, "days");
                                            break;

                                        default:
                                            break;
                                    }

                                    return fd.format("DD/MM/YYYY HH:mm");
                                }


                            }} /> */}



                            {/* <Column title="Action" render={(value, row, index) => {

                                return this.actionTemplate(row);

                            }} /> */}

                        </Table>}
                    </Card>

               </MenuProvider>
                {!this.state.whatIsSetting && <Whatis  ></Whatis>


                }
            </div>
       
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        i18n: state.i18n
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Release) 